import SelfInfoModal from './self-info-modal.vue'
export default SelfInfoModal
